import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f34b75a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progressplaninfo-container" }
const _hoisted_2 = { class: "top-container" }
const _hoisted_3 = { class: "top1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "姓名：", -1))
const _hoisted_5 = { class: "top1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "性别：", -1))
const _hoisted_7 = { class: "top2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "计划来访时间：", -1))
const _hoisted_9 = { class: "top3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "计划结束时间：", -1))
const _hoisted_11 = { class: "top4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "手机号：", -1))
const _hoisted_13 = { class: "top5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "审批状态：", -1))
const _hoisted_15 = { class: "top6" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { style: {"width":"100%","display":"flex","justify-content":"space-between"} }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_20 = { style: {"height":"100%","display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_21 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.name ? _ctx.progressDetail.name : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", null, _toDisplayString(_ctx.approveSexFilter(_ctx.progressDetail.sex)), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.startPlan), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.endPlan), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", null, _toDisplayString(_ctx.progressDetail.phone ? _ctx.progressDetail.phone : ""), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", {
          style: _normalizeStyle({
            color:
              _ctx.progressDetail.status === 0
                ? '#FEA235'
                : _ctx.progressDetail.status === 1
                ? '#C820E0'
                : _ctx.progressDetail.status === 2
                ? '#8893A3'
                : '#E02020',
          })
        }, _toDisplayString(_ctx.approveStatusFilter(_ctx.progressDetail.status)), 5)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("img", {
          src: _ctx.progressDetail.faceUrl,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previewimgfun(this.progressDetail.faceUrl)))
        }, null, 8, _hoisted_16)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_van_button, {
        style: {"width":"48%"},
        round: "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.examine(3)))
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      }),
      _createVNode(_component_van_button, {
        style: {"width":"48%"},
        round: "",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.examine(1)))
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_overlay, {
      show: _ctx.show,
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.show = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("img", {
            src: _ctx.previewimg,
            style: {"height":"60%","width":"100%"}
          }, null, 8, _hoisted_21)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}